module.exports = __webpack_public_path__ + "media/start.8e1a43d9.mp3";